<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Resend Payslip Summary</h3>
        <b-row>
            <b-col cols="12" class="d-flex align-items-center justify-content-center mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 cursor-pointer" width="40" height="40" viewBox="0 0 512 512">
                    <circle fill="#5D79E3" cx="256" cy="256" r="256" />
                    <g fill="#fff" transform="translate(108, 112) scale(12)">
                        <path fill="#fff" d="M4 20q-.825 0-1.413-.588T2 18V6q0-.825.588-1.413T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.588 1.413T20 20H4Zm8-7L4 8v10h16V8l-8 5Zm0-2 8-5H4l8 5ZM4 8V6v12V8Z"/>
                    </g>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 cursor-pointer" width="40" height="40" viewBox="0 0 512 512">
                    <circle fill="#5D79E3" cx="256" cy="256" r="256" />
                    <g fill="#fff" transform="translate(120, 116) scale(0.55)">
                        <path fill="#fff" d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-53.1-271.2c6.5-2.2 13.7.1 17.9 5.6l35.2 46.9 35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6S320 185.1 320 192v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-6.9 4.4-13 10.9-15.2zm173.1 38v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.2-.4-23.7-4.4-32.6-7.4-1.4-.5-2.7-.9-4-1.4-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7.6 3.3 1.1 4.9 1.6 9.1 3.1 15.6 5.3 22.6 5.5 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.4-17.7-14.7-17.7-29.4-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 10 .2 19.7 2.3 27.9 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9zm-272 0v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.3-.4-24.2-4.5-33.2-7.6-1.3-.4-2.5-.8-3.6-1.2-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4.5 2.8.9 4.1 1.4 9.5 3.2 16.5 5.6 23.7 5.8 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.3-17.7-14.6-17.8-29.3-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 9.5.1 22.2 2.1 31.1 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9z"/>
                    </g>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 cursor-pointer" width="40" height="40" viewBox="0 0 512 512">
                    <circle fill="#5D79E3" cx="256" cy="256" r="256" />
                    <g fill="#fff" transform="translate(132, 112) scale(0.55)">
                        <path fill="#fff" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                    </g>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 cursor-pointer" width="40" height="40" viewBox="0 0 512 512">
                    <circle fill="#5D79E3" cx="256" cy="256" r="256" />
                    <g fill="#fff" transform="translate(112, 100) scale(12)">
                        <path fill="#fff" d="M12 15.575q-.2 0-.375-.062T11.3 15.3l-3.6-3.6q-.275-.275-.275-.7t.275-.7q.275-.275.713-.287t.712.262L11 12.15V5q0-.425.288-.713T12 4q.425 0 .713.288T13 5v7.15l1.875-1.875q.275-.275.713-.263t.712.288q.275.275.275.7t-.275.7l-3.6 3.6q-.15.15-.325.213t-.375.062ZM6 20q-.825 0-1.413-.588T4 18v-2q0-.425.288-.713T5 15q.425 0 .713.288T6 16v2h12v-2q0-.425.288-.713T19 15q.425 0 .713.288T20 16v2q0 .825-.588 1.413T18 20H6Z"/>
                    </g>
                </svg>
            </b-col>
            <b-col cols="12">
                <b-input-group>
                    <b-form-input
                    v-model="payslip_link"
                    type="text"
                    readonly
                    ></b-form-input>
                    <b-input-group-append>
                        <b-button variant="primary" class="px-md-5">
                            <b-icon icon="files" aria-hidden="true"></b-icon>
                            Copy
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Avatar, Select, Button } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import {axios, services, getHeader } from '@/assets/js/httpImports.js'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'

export default {
    props:{
        resend_payslip: Boolean
    },
    mixins: [notifyFunctionMixin],
    components: {
        ValidationObserver,
        ValidationProvider,
        [Avatar.name]: Avatar,
        [Select.name]: Select,
        [Button.name]: Button,
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.resend_payslip;
            },
            set(newVal) {
                this.$emit('update:resend_payslip', newVal);
            },
        },
    },
    data(){
        return {
            payslip_link: 'https://sas-demo.imortgage2u.com/123456...'
        }
    },
    created() {
        //
    },
    methods: {
        viewDetails(){
            this.show = true
        }
    }
}
</script>